import SectionHeading from "@/components/base/SectionHeading";
import { collections } from "@/mocks/home";

export default function CollectionSection() {
  return (
    <section id="collections" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
        <SectionHeading
          eyebrow="最新合集"
          title="精选大全：按主题打包好的合集"
          description="合集把同一主题下的作品集中展示，并标注大致收录规模。想系统性地补齐一个方向时，从合集入手效率最高。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
          {collections.map((item) => (
            <article
              key={item.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-200 sm:flex-row"
            >
              <div className="relative h-44 w-full shrink-0 overflow-hidden sm:h-auto sm:w-56">
                <img
                  src={item.image}
                  alt={`${item.title}合集主题配图`}
                  title={`${item.title} 日韩中文字幕合集`}
                  className="h-full w-full object-top"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-2.5 py-1 font-label text-xs font-medium text-background-50">
                  {item.count}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
                  {item.desc}
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 font-label text-xs font-medium text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}